import React, { useEffect } from 'react';

export default function Ended() {
    useEffect(() => {
        window.close();
    }, []);
    
    return (
        <></>
    )
}
